import React from "react";
import "./contactUs.scss";

const ContactUs = () => {
  return (
    <div>
      <h2>Contact Us</h2>
      <h4>Petroen Engineering DMCC</h4>
      
     
      <ul className="contact-info">
        
        <li>Mob: +971 569716822</li>
        <li> WhatsApp: +971 558942436</li>
        <li>Email: Khurram.latif@Petro-en.com</li>
        <li></li>
      </ul>
    </div>
  );
};
export default ContactUs;
